<template>
  <div style="" class="hidden-md-and-up">
    <div class="mobile_nav_wrap hidden-md-and-up">
      <div class="navbar_left" >
        <img :src="logoImg" alt="logo" class="logo-img" @click="gobackHome"/>
        <!-- <span class="brand-title">华软股份</span> -->
      </div>
      <div class="navbar_right">
        <img
          :src="phoneImg"
          alt="phone"
          class="phone-img"
          @click="showPhoneDialog = true"
        />
        <div class="nav_consult" @click="gotoConsult">立即咨询</div>
        <div  @click="showMenuDialog = true" style="padding-left: 16px;">
        <img
          :src="menuIcon"
          alt="menu"
          class="menu-icon-img"
         
        />
        </div>

        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <div style="height: 40px"></div>
    <!-- 全屏弹窗 -->
    <div v-if="showMenuDialog" class="menu-dialog-overlay">
      <div class="menu-dialog-content">
        <span class="menu-dialog-close" @click="showMenuDialog = false">×</span>
        <div class="menu-dialog-divider"></div>
        <div class="menu-dialog-inner menu-dialog-tabs">
          <ul class="menu-list-tabs">
            <li
              v-for="item in menuItems"
              :key="item.key"
              :class="['menu-tab', { active: activeMenu === item.key }]"
              @click="selectMenu(item.key)"
            >
              <span>{{ item.label }}</span>
              <!-- <span
                v-if="item.hasArrow"
                class="arrow"
                :class="{ up: expanded[item.key] }"
                @click="toggleMenu(item.key)"
              ></span> -->
            </li>
          </ul>
          <div class="menu-tab-content">
            <!-- 原来的菜单内容区域，按需显示子菜单 -->
            <template v-if="activeMenu === 'product'">
              <ul class="submenu-list">
                <li
                  class="submenu-item"
                  @click="toggleMenu('product')"
                  :class="{
                    expanded: expanded.product,
                    selected: isProductSelected('product_lie_1'),
                  }"
                >
                  地空协同智能航空站(自动机场)<span class="arrow" :class="{ up: expanded.product }"></span>
                </li>
                <ul v-if="expanded.product" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_1', '集群式换电航站', 0)"
                    :class="{ selected: isProductSelected('product_lie_1') }"
                  >
                    <img
                      :src="productImages[0].items[0].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">集群式换电航站</span>
                    <span class="hot">HOT</span>
                    
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_2', '换电式自动机场', 1)"
                    :class="{ selected: isProductSelected('product_lie_2') }"
                  >
                    <img
                      :src="productImages[0].items[1].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">换电式自动机场</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_3', '充电式自动机场', 2)"
                    :class="{ selected: isProductSelected('product_lie_3') }"
                  >
                    <img
                      :src="productImages[0].items[2].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">充电式自动机场</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_4', '垂起固定翼机场', 3)"
                    :class="{ selected: isProductSelected('product_lie_4') }"
                  >
                    <img
                      :src="productImages[0].items[3].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">垂起固定翼机场</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_5', '大载重自动机场', 4)"
                    :class="{ selected: isProductSelected('product_lie_5') }"
                  >
                    <img
                      :src="productImages[0].items[4].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">大载重自动机场</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_5_1', '空地一体母站', 5)"
                    :class="{ selected: isProductSelected('product_lie_5_1') }"
                  >
                    <img
                      :src="productImages[0].items[5].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">空地一体母站</span>
                    <span  class="hot">NEW</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_6', '移动航空站')"
                    :class="{ selected: isProductSelected('product_lie_6') }"
                  >
                    <img
                      :src="productImages[0].items[6].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">移动航空站</span>
                    <span class="hot" v-if="true">HOT</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_7', '无人装备指挥车')"
                    :class="{ selected: isProductSelected('product_lie_7') }"
                  >
                    <img
                      :src="productImages[0].items[7].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">无人装备指挥车</span>
                  </li>
                </ul>
                <!-- <li class="submenu-item" @click="toggleMenu('mobileStation')"
                  :class="{ expanded: expanded.mobileStation }">
                  移动航空站系列
                  <span class="arrow" :class="{ up: expanded.mobileStation }"></span>
                </li>
                <ul v-if="expanded.mobileStation" class="submenu-list2">
                  <li class="submenu-item2" @click="goProductLie('product_lie_6', '移动航空站')">
                    <img :src="pro1_1" alt="" class="submenu-item2-img" />
                    <span style="margin-left:8PX;">移动航空站</span>
                    <span class="hot" v-if="true">HOT</span>
                  </li>
                  <li class="submenu-item2" @click="goProductLie('product_lie_7', '无人装备指挥车')">
                    <img :src="pro1_1" alt="" class="submenu-item2-img" />
                    <span style="margin-left:8PX;">无人装备指挥车</span>
                  </li>
                </ul> -->
                <li
                  class="submenu-item"
                  @click="toggleMenu('car')"
                  :class="{ expanded: expanded.car }"
                >
                  陆空协同无人车(机器人)<span class="arrow" :class="{ up: expanded.car }"></span>
                </li>
                <ul v-if="expanded.car" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_8', '陆空协同无人消防车')"
                    :class="{ selected: isProductSelected('product_lie_8') }"
                  >
                    <img
                      :src="productImages[1].items[0].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">陆空协同无人消防车</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="
                      goProductLie('product_lie_9', '陆空协同应急处置机器人')
                    "
                    :class="{ selected: isProductSelected('product_lie_9') }"
                  >
                    <img
                      :src="productImages[1].items[1].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">陆空协同应急处置机器人</span>
                  </li>

                  <li
                    class="submenu-item2"
                    @click="
                      goProductLie('product_lie_8_1', '陆空协同智能巡视机器人')
                    "
                    :class="{ selected: isProductSelected('product_lie_8_1') }"
                  >
                    <img
                      :src="productImages[1].items[2].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">陆空协同智能巡视机器人</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="
                      goProductLie('product_lie_8_2', '室内应急处置机器人')
                    "
                    :class="{ selected: isProductSelected('product_lie_8_2') }"
                  >
                    <img
                      :src="productImages[1].items[3].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">室内应急处置机器人</span>
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('ship')"
                  :class="{ expanded: expanded.ship }"
                >
                  海空协同无人船(艇)
                  <span class="arrow" :class="{ up: expanded.ship }"></span>
                </li>
                <ul v-if="expanded.ship" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="
                      goProductLie('product_lie_10', '海空协同无人船（艇）')
                    "
                    :class="{ selected: isProductSelected('product_lie_10') }"
                  >
                    <img
                      :src="productImages[2].items[0].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">海空协同无人船（艇）</span>
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('software')"
                  :class="{ expanded: expanded.software }"
                >
                  软件系统
                  <span class="arrow" :class="{ up: expanded.software }"></span>
                </li>
                <ul v-if="expanded.software" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_11', '智能全域巡视系统')"
                    :class="{ selected: isProductSelected('product_lie_11') }"
                  >
                    <img
                      :src="productImages[3].items[0].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">智能全域巡视系统</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_12', '全域电网巡检系统')"
                    :class="{ selected: isProductSelected('product_lie_12') }"
                  >
                    <img
                      :src="productImages[3].items[1].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">全域电网巡检系统</span>
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('board')"
                  :class="{ expanded: expanded.board }"
                >
                  全国产化智能大、小脑(服务器)<span class="arrow" :class="{ up: expanded.board }"></span>
                </li>
                <ul v-if="expanded.board" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_13', '机载智能大脑')"
                    :class="{ selected: isProductSelected('product_lie_13') }"
                  >
                    <img
                      :src="productImages[4].items[0].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">机载智能大脑</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_13_1', '车(船)载智能大(小)脑')"
                    :class="{ selected: isProductSelected('product_lie_13_1') }"
                  >
                    <img
                      :src="productImages[4].items[1].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">车(船)载智能大(小)脑</span>
                  </li>
                    <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_13_2', '边端算力服务器')"
                    :class="{ selected: isProductSelected('product_lie_13_2') }"
                  >
                    <img
                      :src="productImages[4].items[2].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">边端算力服务器</span>
                  </li>
                    <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_14', '云端算力服务器')"
                    :class="{ selected: isProductSelected('product_lie_14') }"
                  >
                    <img
                      :src="productImages[4].items[3].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">云端算力服务器</span>
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('other')"
                  :class="{ expanded: expanded.other }"
                >
                  其他产品
                  <span class="arrow" :class="{ up: expanded.other }"></span>
                </li>
                <ul v-if="expanded.other" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_15', '系留供电装置')"
                    :class="{ selected: isProductSelected('product_lie_15') }"
                  >
                    <img
                      :src="productImages[5].items[0].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">系留供电装置</span>
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_16', '无人装备便携地面站')"
                    :class="{ selected: isProductSelected('product_lie_16') }"
                  >
                    <img
                      :src="productImages[5].items[1].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">无人装备便携地面站</span>
                  </li>
                  <!-- <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_18', '机载任务系统')"
                    :class="{ selected: isProductSelected('product_lie_18') }"
                  >
                    <img
                      :src="productImages[5].items[2].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">机载任务系统</span>
                  </li> -->
                  <li
                    class="submenu-item2"
                    @click="goProductLie('product_lie_17', '无人装备驾控台')"
                    :class="{ selected: isProductSelected('product_lie_17') }"
                  >
                    <img
                      :src="productImages[5].items[2].img"
                      alt=""
                      class="submenu-item2-img"
                    />
                    <span style="margin-left: 8px">无人装备驾控台</span>
                  </li>
                </ul>
              </ul>
            </template>
            <template v-if="activeMenu === 'industry'">
              <ul class="submenu-list">
                <!-- 行业应用菜单始终显示，展开/收缩仅控制子菜单 -->
                <li
                  class="submenu-item"
                  @click="toggleMenu('Loweconomy')"
                  :class="{
                    expanded: expanded.Loweconomy,
                    selected: isIndustrySelected('industry_uav_safe'),
                  }"
                >
                  低空经济
                  <span
                    class="arrow"
                    :class="{ up: expanded.Loweconomy }"
                  ></span>
                </li>
                <ul v-if="expanded.Loweconomy" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_uav_safe', '无人+公共安全')"
                    :class="{
                      selected: isIndustrySelected('industry_uav_safe'),
                    }"
                  >
                    无人+公共安全
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_safety_1', '无人+执法')"
                    :class="{
                      selected: isIndustrySelected('industry_safety_1'),
                    }"
                  >
                    无人+执法
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_safety_2', '无人+应急')"
                    :class="{
                      selected: isIndustrySelected('industry_safety_2'),
                    }"
                  >
                    无人+应急
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_other_4', '无人+环保')"
                    :class="{
                      selected: isIndustrySelected('industry_other_4'),
                    }"
                  >
                    无人+环保
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_uav_forest', '无人+森林')"
                    :class="{
                      selected: isIndustrySelected('industry_uav_forest'),
                    }"
                  >
                    无人+森林
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_uav_water', '无人+水利')"
                    :class="{
                      selected: isIndustrySelected('industry_uav_water'),
                    }"
                  >
                    无人+水利
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_uav_delivery', '无人+投送')"
                    :class="{
                      selected: isIndustrySelected('industry_uav_delivery'),
                    }"
                  >
                    无人+投送
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('Powergrid')"
                  :class="{
                    expanded: expanded.Powergrid,
                    selected: isIndustrySelected('industry_power_1'),
                  }"
                >
                  电网
                  <span
                    class="arrow"
                    :class="{ up: expanded.Powergrid }"
                  ></span>
                </li>
                <ul v-if="expanded.Powergrid" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_power_1', '输电线路')"
                    :class="{
                      selected: isIndustrySelected('industry_power_1'),
                    }"
                  >
                    输电线路
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_power_2', '变电（换流）站')"
                    :class="{
                      selected: isIndustrySelected('industry_power_2'),
                    }"
                  >
                    变电（换流）站
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_power_3', '配网')"
                    :class="{
                      selected: isIndustrySelected('industry_power_3'),
                    }"
                  >
                    配网
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('newsEnergy')"
                  :class="{
                    expanded: expanded.newsEnergy,
                    selected: isIndustrySelected('industry_energy_1'),
                  }"
                >
                  新能源
                  <span
                    class="arrow"
                    :class="{ up: expanded.newsEnergy }"
                  ></span>
                </li>
                <ul v-if="expanded.newsEnergy" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_energy_1', '光伏发电')"
                    :class="{
                      selected: isIndustrySelected('industry_energy_1'),
                    }"
                  >
                    光伏发电
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_energy_2', '风力发电')"
                    :class="{
                      selected: isIndustrySelected('industry_energy_2'),
                    }"
                  >
                    风力发电
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_energy_3', '抽水蓄能')"
                    :class="{
                      selected: isIndustrySelected('industry_energy_3'),
                    }"
                  >
                    抽水蓄能
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('Energy')"
                  :class="{
                    expanded: expanded.Energy,
                    selected: isIndustrySelected('industry_energy_4'),
                  }"
                >
                  能源
                  <span class="arrow" :class="{ up: expanded.Energy }"></span>
                </li>
                <ul v-if="expanded.Energy" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_energy_4', '石油')"
                    :class="{
                      selected: isIndustrySelected('industry_energy_4'),
                    }"
                  >
                    石油
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_energy_5', '天然气')"
                    :class="{
                      selected: isIndustrySelected('industry_energy_5'),
                    }"
                  >
                    天然气
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_guan_wang', '管网')"
                    :class="{
                      selected: isIndustrySelected('industry_guan_wang'),
                    }"
                  >
                    管网
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_other_3', '矿业')"
                    :class="{
                      selected: isIndustrySelected('industry_other_3'),
                    }"
                  >
                    矿业
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('RailTransit')"
                  :class="{
                    expanded: expanded.RailTransit,
                    selected: isIndustrySelected('industry_gong_lu'),
                  }"
                >
                  轨道交通
                  <span
                    class="arrow"
                    :class="{ up: expanded.RailTransit }"
                  ></span>
                </li>
                <ul v-if="expanded.RailTransit" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_gong_lu', '公路')"
                    :class="{
                      selected: isIndustrySelected('industry_gong_lu'),
                    }"
                  >
                    公路
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_tie_lu', '铁路')"
                    :class="{ selected: isIndustrySelected('industry_tie_lu') }"
                  >
                    铁路
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_di_tie', '地铁')"
                    :class="{ selected: isIndustrySelected('industry_di_tie') }"
                  >
                    地铁
                  </li>
                </ul>
                <li
                  class="submenu-item"
                  @click="toggleMenu('otherIndustry')"
                  :class="{
                    expanded: expanded.otherIndustry,
                    selected: isIndustrySelected('industry_other_2'),
                  }"
                >
                  其他
                  <span
                    class="arrow"
                    :class="{ up: expanded.otherIndustry }"
                  ></span>
                </li>
                <ul v-if="expanded.otherIndustry" class="submenu-list2">
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_other_2', '边海防')"
                    :class="{
                      selected: isIndustrySelected('industry_other_2'),
                    }"
                  >
                    边海防
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_other_5', '港口')"
                    :class="{
                      selected: isIndustrySelected('industry_other_5'),
                    }"
                  >
                    港口
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_other_6', '基础建设')"
                    :class="{
                      selected: isIndustrySelected('industry_other_6'),
                    }"
                  >
                    基础建设
                  </li>
                  <li
                    class="submenu-item2"
                    @click="goIndustry('industry_hai_yang', '海洋')"
                    :class="{
                      selected: isIndustrySelected('industry_hai_yang'),
                    }"
                  >
                    海洋
                  </li>
                </ul>
              </ul>
            </template>
            <template v-if="activeMenu === 'userCase'">
              <!-- <ul class="submenu-list2" style="padding-left: 20PX;">
                <li class="submenu-item2" @click="goUserCase(1)">电力</li>
                <li class="submenu-item2" @click="goUserCase(2)">公共安全</li>
                <li class="submenu-item2" @click="goUserCase(3)">能源</li>
                <li class="submenu-item2" @click="goUserCase(4)">其他</li>
              </ul> -->
              <div class="user_case_dropdown_mobile">
                <div
                  class="user_case_item"
                  v-for="(item, index) in userCases"
                  @click="naviUserTo('all_user_cases', item.id)"
                  :key="index"
                  :style="{
                    height: `${carouselHeight + 10}px`,
                  }"
                >
                  <div class="user_case_item-box" :style="{
                    backgroundImage: `url(${item.background})`,
                    height: `${carouselHeight}px`,
                  }">
                    <div class="user_case_content">
                      <!-- <h4>{{ item.title }} </h4> -->
                      <p
                        :style="{
                          fontWeight:
                            item.id == $route.query.navUserCaseType ||
                            item.id == $route.query.userCaseType
                              ? 'bold'
                              : 'bold',
                          fontSize: carouselFontSize,
                        }"
                      >
                        {{ item.subtitle }}
                      </p>
                    </div>
                    <img
                      src="@/assets/home/arrow.png"
                      class="arrow_icon"
                      alt="arrow"
                    />
                  </div>
                </div>
              </div>
            </template>
            <!-- <template v-if="activeMenu === 'news_center'">
              <div class="menu-tab-simple" @click="goPage('/news_center')">新闻中心</div>
            </template>
            <template v-if="activeMenu === 'about_us'">
              <div class="menu-tab-simple" @click="goPage('/about_us')">关于我们</div>
            </template> -->
          </div>
        </div>
      </div>
    </div>

    <ConsultDialogMobile
      v-if="showConsultDialog"
      @close="showConsultDialog = false"
      :visible="showConsultDialog"
      @submit="handleConsultSubmit"
    >
    </ConsultDialogMobile>
    <el-dialog
      :visible.sync="dialogVisible"
      width="270PX"
      class="consult-dialog"
      style="margin-top: 35%"
    >
      <div class="dialog-content">
        <div class="icon"></div>
        <p style="font-size: 16px">信息已提交，请耐心等待...</p>
        <el-button type="primary" @click="dialogVisible = false"
          >知道了</el-button
        >
      </div>
    </el-dialog>

    <!-- 新增：电话二维码弹窗 -->
    <div
      v-if="showPhoneDialog"
      class="custom-phone-dialog-overlay"
      @click.self="showPhoneDialog = false"
    >
      <div class="custom-phone-dialog-content">
        <!-- <span class="custom-phone-dialog-close" @click="showPhoneDialog = false">×</span> -->
        <div style="text-align: center">
          <div class="phone-label">联系电话：<a :href="'tel:' + '400-608-3777'">400-608-3777</a></div>
          <!-- <img src="@/assets/home/erWeiMa.png" alt="扫码关注" style="width:200px;height:200px;" />
          <div class="maTxt">长按识别二维码关注公众号</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoImg from "@/assets/home/logo_2.png";
import phoneImg from "@/assets/home/phone.png";
import menuIcon from "@/assets/home/menuIcon.png";
import pro1_1 from "@/assets/home/pro1_1.png";
import pro1_2 from "@/assets/home/V130.png";
import pro1_3 from "@/assets/home/C140.png";
import pro1_4 from "@/assets/home/VF7.png";
import pro1_5 from "@/assets/home/大载重机场2.png";
import ConsultDialogMobile from "./ConsultDialogMobile.vue";

export default {
  components: {
    ConsultDialogMobile,
  },
  data() {
    return {
      showMenuDialog: false,
      showConsultDialog: false,
      dialogVisible: false,
      showPhoneDialog: false, // 新增
      expanded: {
        home: false,
        product: true,
        airport: false,
        mobileStation: false,
        car: false,
        ship: false,
        board: false,
        software: false,
        other: false,
        industry: false,
        // 行业应用相关子菜单
        power: false, // 低空经济
        energy: false, // 电网
        safety: false, // 新能源、能源、轨道交通（共用）
        newsEnergy: false, // 新能源
        Energy: false, // 能源
        RailTransit: false, // 轨道交通
        otherIndustry: false, // 其他
        // 用户案例
        userCase: false,
        Loweconomy: false, // 低空经济
        // 其他可能的子菜单
        Low_economy: false, // 低空经济（key不能有空格，建议统一命名）
        Powergrid: false, // 电网
        NewsEnergy: false, // 新能源
        Rail_Transit: false, // 轨道交通
        Other: false, // 其他
      },
      activeMenu: "product", // 默认选中第一个tab
      menuItems: [
        { key: "home", label: "首页", hasArrow: false },
        { key: "product", label: "产品系列", hasArrow: true },
        { key: "industry", label: "行业应用", hasArrow: true },
        { key: "userCase", label: "用户案例", hasArrow: true },
        { key: "news_center", label: "新闻中心", hasArrow: false },
        { key: "about_us", label: "关于我们", hasArrow: false },
      ],
      userCases: [
        // { id: 1, title: "Power", subtitle: "电力", background: require("@/assets/home/userCaseNav1.png") },
        // { id: 3, title: "Public safety", subtitle: "公共安全", background: require("@/assets/home/userCaseNav2.png") },
        // { id: 2, title: "Energy", subtitle: "能源", background: require("@/assets/home/userCaseNav3.png") },
        // { id: 4, title: "Other", subtitle: "其他", background: require("@/assets/home/userCaseNav4.png") },
        {
          id: 1,
          title: "Low economy",
          subtitle: "低空经济",
          background: require("@/assets/home/userCaseNav1.png"),
        },
        {
          id: 2,
          title: "Powergrid",
          subtitle: "电网",
          background: require("@/assets/home/userCaseNav2.png"),
        },
        {
          id: 3,
          title: "New energy",
          subtitle: "新能源",
          background: require("@/assets/home/userCaseNav3.png"),
        },
        {
          id: 4,
          title: "Energy",
          subtitle: "能源",
          background: require("@/assets/home/userCaseNav4.png"),
        },
        {
          id: 5,
          title: "Rail Transit",
          subtitle: "轨道交通",
          background: require("@/assets/home/userCaseNav5.png"),
        },
        {
          id: 6,
          title: "Other",
          subtitle: "其他",
          background: require("@/assets/home/userCaseNav6.png"),
        },
      ],
      productImages: [
        {
          title: "地空协同智能航空站（自动机场）",
          items: [
            {
              img: "https://hr2.chnsoft.com.cn/img/D51.png",
              alt: "集群式换电航站",
              text: "集群式换电航站",
              isHot: true,
              route: "product_lie_1",
            },
            {
              img: require("@/assets/home/V400Icon.png"),
              alt: "换电式自动机场",
              text: "换电式自动机场",
              isHot: false,
              route: "product_lie_2",
            },
            {
              img: require("@/assets/home/C350Icon.png"),
              alt: "充电式自动机场",
              text: "充电式自动机场",
              isHot: false,
              route: "product_lie_3",
            },
            {
              img: require("@/assets/home/VF7.png"),
              alt: "垂起固定翼机场",
              text: "垂起固定翼机场",
              isHot: false,
              route: "product_lie_4",
            },
            {
              img: require("@/assets/home/大载重机场2.png"),
              alt: "大载重自动机场",
              text: "大载重自动机场",
              isHot: false,
              route: "product_lie_5",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/空地一体母站.png",
              alt: "空地一体母站",
              text: "空地一体母站",
              isNew: false,
              route: "product_lie_5_1",
            },
            {
              img: 'https://hr2.chnsoft.com.cn/img/移动航空站.png',
              alt: "移动航空站",
              text: "移动航空站",
              isHot: true,
              route: "product_lie_6",
            },
            {
              img: require("@/assets/home/应急指挥车.png"),
              alt: "无人装备指挥车",
              text: "无人装备指挥车",
              isHot: false,
              route: "product_lie_7",
            },
          ],
        },
        // {
        //   title: "移动航空站系列",
        //   items: [
        //     { img: 'https://hr2.chnsoft.com.cn/img/移动航空站.png', alt: "移动航空站", text: "移动航空站", isHot: true, route: "product_lie_6" },
        //     { img: require("@/assets/home/应急指挥车.png"), alt: "无人装备指挥车", text: "无人装备指挥车", isHot: false, route: "product_lie_7" },
        //   ],
        // },
        {
          title: "陆空协同无人车（机器人）",
          items: [
            {
              img: require("@/assets/home/压缩空气泡沫智能消防车@1x.png"),
              alt: "陆空协同无人消防车",
              text: "陆空协同无人消防车",
              isHot: false,
              route: "product_lie_8",
            },
            {
              img: require("@/assets/home/应急处置机器人.png"),
              alt: "陆空协同应急处置机器人",
              text: "陆空协同应急处置机器人",
              isHot: false,
              route: "product_lie_9",
            },
            {
              img: require("@/assets/home/智能巡视机器人.png"),
              alt: "陆空协同智能巡视机器人",
              text: "陆空协同智能巡视机器人",
              isHot: false,
              route: "product_lie_8_1",
            },
            {
              img: require("@/assets/home/室内应急处置机器人.png"),
              alt: "室内应急处置机器人",
              text: "室内应急处置机器人",
              isHot: false,
              route: "product_lie_8_2",
            },
          ],
        },
        {
          title: "海空协同无人船（艇）",
          items: [
            {
              img: require("@/assets/home/水上智能航空站.png"),
              alt: "海空协同无人船（艇）",
              text: "海空协同无人船（艇）",
              isHot: false,
              route: "product_lie_10",
            },
          ],
        },
        {
          title: "软件系统",
          items: [
            {
              img: require("@/assets/home/ruanJian1.png"),
              alt: "智能全域巡视系统",
              text: "智能全域巡视系统",
              isHot: false,
              route: "product_lie_11",
            },
            {
              img: 'https://hr2.chnsoft.com.cn/img/ruanJian2.png',
              alt: "全域电网巡检系统",
              text: "全域电网巡检系统",
              isHot: false,
              route: "product_lie_12",
            },
          ],
        },
        {
          title: "全国产化智能大、小脑（服务器）",
          items: [
            {
              img: "https://hr2.chnsoft.com.cn/img/机载智能大脑.png",
              alt: "机载智能大脑",
              text: "机载智能大脑",
              isHot: false,
              route: "product_lie_13",
            },
            {
              img: require("@/assets/home/ZF3588.png"),
              alt: "车(船)载智能大(小)脑",
              text: "车(船)载智能大(小)脑",
              isHot: false,
              route: "product_lie_13_1",
            },
            {
              img: require("@/assets/home/ZF-C200 边缘计算终端.png"),
              alt: "边端算力服务器",
              text: "边端算力服务器",
              isHot: false,
              route: "product_lie_13_2",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/%E4%BA%91%E7%AB%AF%E7%AE%97%E5%8A%9B%E6%9C%8D%E5%8A%A1%E5%99%A8%402x.webp",
              alt: "云端算力服务器",
              text: "云端算力服务器",
              isHot: false,
              route: "product_lie_14",
            },
          ],
        },
        {
          title: "其他产品",
          items: [
            {
              img: "https://hr2.chnsoft.com.cn/img/xiliunew.png",
              alt: "系留供电装置",
              text: "系留供电装置",
              isHot: false,
              route: "product_lie_15",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/CGS-C03 集控飞行地面站.png",
              alt: "无人装备便携地面站",
              text: "无人装备便携地面站",
              isHot: false,
              route: "product_lie_16",
            },
            // {
            //   img: require("@/assets/home/pro5_3.png"),
            //   alt: "机载任务系统",
            //   text: "机载任务系统",
            //   isHot: false,
            //   route: "product_lie_18",
            // },
            {
              img: "https://hr2.chnsoft.com.cn/img/CGS-100 集控飞行座舱.png",
              alt: "无人装备驾控台",
              text: "无人装备驾控台",
              isHot: false,
              route: "product_lie_17",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.setActiveMenuByRoute();
    this.$watch("$route", this.setActiveMenuByRoute);
    // this.setCarouselHeight();
    // window.addEventListener('resize', this.setCarouselHeight);
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.setCarouselHeight);
  },
  methods: {
    gotoConsult() {
      // this.$router.push('/consult').catch(() => {})
      this.showConsultDialog = true;
    },
    gobackHome() {
      this.$router.replace("/home").catch(() => {});
    },
    moveMenu() {},
    goPage(path) {
      this.showMenuDialog = false;
      this.$router.push(path).catch(() => {});
    },
    naviUserTo(route, id) {
      this.showMenuDialog = false;

      if (route) {
        this.$router.push({
          path: "/all_user_cases",
          query: { source: route, navUserCaseType: id },
        });
      }
      localStorage.setItem("activeNav", "userCase");
    },
    toggleMenu(key) {
      // 只展开当前点击的菜单，关闭同级其他菜单
      Object.keys(this.expanded).forEach((k) => {
        if (k === key) {
          this.$set(this.expanded, k, !this.expanded[k]);
        } else if (
          // 产品系列同级互斥
          ["product", "car", "ship", "board", "software", "other"].includes(
            key
          ) &&
          ["product", "car", "ship", "board", "software", "other"].includes(k)
        ) {
          this.$set(this.expanded, k, false);
        } else if (
          // 行业应用同级互斥
          [
            "Loweconomy",
            "Powergrid",
            "newsEnergy",
            "Energy",
            "RailTransit",
            "otherIndustry",
          ].includes(key) &&
          [
            "Loweconomy",
            "Powergrid",
            "newsEnergy",
            "Energy",
            "RailTransit",
            "otherIndustry",
          ].includes(k)
        ) {
          this.$set(this.expanded, k, false);
        }
      });
    },

    handleConsultSubmit() {
      this.showConsultDialog = false;
      this.dialogVisible = true;
    },
    goProductLie(route, text, index) {
      this.showMenuDialog = false;
      if (text) {
        localStorage.setItem("selectedText", text);
        if (text == "海空协同无人船（艇）") {
          localStorage.setItem("TeDianBgProName", "水上智能航空站");
        } else if (text == "陆空协同无人消防车") {
          localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
        } else if (text == "算力服务器") {
          localStorage.setItem("TeDianBgProName", "ZF-C200 边缘计算终端");
        } else if (text == "机载板卡") {
          localStorage.setItem("TeDianBgProName", "ZF-A400 算力板卡");
        } else if (text == "系留供电装置") {
          localStorage.setItem("TeDianBgProName", "系留供电装置");
        } else if (text == "无人装备便携地面站") {
          localStorage.setItem("TeDianBgProName", "无人装备便携地面站");
        } else if (text == "机载任务系统") {
          localStorage.setItem("TeDianBgProName", "AMS-400-V112 机载任务系统");
        } else if (text == "无人装备驾控台") {
          localStorage.setItem("TeDianBgProName", "无人装备驾控台");
        } else if (text == "智能全域巡视系统") {
          localStorage.setItem("TeDianBgProName", "智能全域巡视系统");
        } else if (text == "全域电网巡检系统") {
          localStorage.setItem("TeDianBgProName", "全域电网巡检系统");
        } else {
          localStorage.setItem("TeDianBgProName", text);
        }
      }
      // 可根据 index 做更多处理
      this.$router
        .push({ path: "/product_lie", query: { source: route } })
        .catch(() => {});
    },
    goIndustry(route, text) {
      this.showMenuDialog = false;
      if (text) {
        localStorage.setItem("selectedText", text);
        localStorage.setItem("TeDianBgProName", text);
      }
      this.$router
        .push({ path: "/industry_application", query: { source: route } })
        .catch(() => {});
    },
    goUserCase(id) {
      this.showMenuDialog = false;
      this.$router
        .push({
          path: "/all_user_cases",
          query: { source: "all_user_cases", navUserCaseType: id },
        })
        .catch(() => {});
    },
    selectMenu(key) {
      this.activeMenu = key;
      // 展开箭头菜单
      if (["product", "industry", "userCase"].includes(key)) {
        this.$set(this.expanded, key, true);
      }
      // 修正：行业应用默认展开第一个子菜单
      if (key === "industry") {
        this.$set(this.expanded, "Loweconomy", true);
        this.$set(this.expanded, "energy", false);
        this.$set(this.expanded, "safety", false);
        this.$set(this.expanded, "newsEnergy", false);
        this.$set(this.expanded, "Energy", false);
        this.$set(this.expanded, "RailTransit", false);
        this.$set(this.expanded, "otherIndustry", false);
      }
      if (key === "about_us") {
        this.navigateToAboutUs();
      } else if (key === "news_center") {
        this.navigateToNews();
      } else if (key === "home") {
        this.navigateToHome();
      }
    },
    navigateToHome() {
      this.activeMenu = "product";
      this.showMenuDialog = false;
      this.$router.push({ path: "/home" });
    },
    navigateToAboutUs() {
      this.activeMenu = "product";
      if (this.$route.path == "/about_us") {
        this.showMenuDialog = false;
      } else {
        this.$router.push({ path: "/about_us" });
      }

      // localStorage.setItem('activeNav', 'about');
    },

    navigateToNews() {
      this.activeMenu = "product";
      if (this.$route.path == "/news_center") {
        this.showMenuDialog = false;
      } else {
        this.$router.push({ path: "/news_center" });
      }
      // localStorage.setItem('activeNav', 'news');
    },
    setActiveMenuByRoute() {
      const path = this.$route.path;
      if (path.startsWith("/home")) {
        this.activeMenu = "product";
      } else if (path.startsWith("/product_lie")) {
        this.activeMenu = "product";
        // 自动展开选中的产品系列子菜单
        const source = this.$route.query.source;
        // route 到 expanded 的 key 映射
        const sourceToExpanded = {
          product_lie_1: "product",
          product_lie_2: "product",
          product_lie_3: "product",
          product_lie_4: "product",
          product_lie_5: "product",
          product_lie_5_1: "product",
          product_lie_6: "product",
          product_lie_7: "product",
          product_lie_8: "car",
          product_lie_9: "car",
          product_lie_8_1: "car",
          product_lie_8_2: "car",
          product_lie_10: "ship",
          product_lie_11: "software",
          product_lie_12: "software",
          product_lie_13: "board",
          product_lie_13_1: "board",
          product_lie_13_2: "board",
          product_lie_14: "board",
          product_lie_15: "other",
          product_lie_16: "other",
          product_lie_17: "other",
          product_lie_18: "other",
        };
        Object.keys(this.expanded).forEach((k) => {
          if (sourceToExpanded[source] === k) {
            this.$set(this.expanded, k, true);
          } else if (
            ["product", "car", "ship", "board", "software", "other"].includes(k)
          ) {
            this.$set(this.expanded, k, false);
          }
        });
      } else if (path.startsWith("/industry_application")) {
        this.activeMenu = "industry";
        // 自动展开选中的行业应用子菜单
        const source = this.$route.query.source;
        // 这里根据你的路由source和expanded的key做映射
        const sourceToExpanded = {
          industry_uav_safe: "Loweconomy",
          industry_safety_1: "Loweconomy",
          industry_safety_2: "Loweconomy",
          industry_other_4: "Loweconomy",
          industry_uav_forest: "Loweconomy",
          industry_uav_water: "Loweconomy",
          industry_uav_delivery: "Loweconomy",
          industry_power_1: "Powergrid",
          industry_power_2: "Powergrid",
          industry_power_3: "Powergrid",
          industry_energy_1: "newsEnergy",
          industry_energy_2: "newsEnergy",
          industry_energy_3: "newsEnergy",
          industry_energy_4: "Energy",
          industry_energy_5: "Energy",
          industry_guan_wang: "Energy",
          industry_other_3: "Energy",
          industry_gong_lu: "RailTransit",
          industry_tie_lu: "RailTransit",
          industry_di_tie: "RailTransit",
          industry_other_2: "otherIndustry",
          industry_other_5: "otherIndustry",
          industry_other_6: "otherIndustry",
          industry_hai_yang: "otherIndustry",
        };
        Object.keys(this.expanded).forEach((k) => {
          if (sourceToExpanded[source] === k) {
            this.$set(this.expanded, k, true);
          } else if (
            [
              "Loweconomy",
              "Powergrid",
              "newsEnergy",
              "Energy",
              "RailTransit",
              "otherIndustry",
            ].includes(k)
          ) {
            this.$set(this.expanded, k, false);
          }
        });
      } else if (
        path.startsWith("/all_user_cases") ||
        path.startsWith("/user_case_detail")
      ) {
        this.activeMenu = "userCase";
      } else if (
        path.startsWith("/news_center") ||
        path.startsWith("/news_detail_mobile")
      ) {
        this.activeMenu = "product";
      } else if (path.startsWith("/about_us")) {
        this.activeMenu = "product";
      }
    },
    isProductSelected(route) {
      // 判断当前路由是否匹配
      return (
        this.$route.path.startsWith("/product_lie") &&
        this.$route.query.source === route
      );
    },
    isIndustrySelected(route) {
      // 判断当前路由是否匹配
      return (
        this.$route.path.startsWith("/industry_application") &&
        this.$route.query.source === route
      );
    },
  },
  computed: {
    logoImg() {
      return logoImg;
    },
    phoneImg() {
      return phoneImg;
    },
    menuIcon() {
      return menuIcon;
    },
    carouselHeight() {
      // 路由地址为 /industry_application 时高度为 1080PX，否则根据分辨率判断
      // if (this.$route.path === '/industry_application') {
      //   return '1080PX';
      // }
      const h = window.innerWidth || window.screen.width;
      // debugger;
      if (h > 765) {
        return 200;
      } else {
        return 65;
      }
    },
    carouselFontSize() {
      const h = window.innerWidth || window.screen.width;
      if (h > 765) {
        return "14PX";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 0 0 0 15px; // 0.9375rem -> 15PX
  align-items: center;
  position: fixed;
  top: 0;
  overflow-x: hidden;

  .navbar_left {
    display: flex;
    align-items: center;
    flex: 1;
    background: #fff;
    cursor: pointer;

    .logo-img {
      height: 20px;
      width: auto;
      margin-right: 8px; // 0.5rem -> 8PX
    }

    .brand-title {
      font-size: 11px;
      color: #11457c;
      font-weight: bold;
      letter-spacing: 2px; // 0.125rem -> 2PX
    }
  }

  .navbar_right {
    flex: none;
    display: flex;
    align-items: center;
    background: #fff;

    .phone-img {
      width: 24px;
      height: 24px;
      margin-right: 8px; // 1rem -> 16PX
    }

    .nav_consult {
      width: 80px;
      height: 24px;
      line-height: 24px;
      background: #0f6bf6;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      border-radius: 3px; // 0.375rem -> 6PX
      
      // margin-right: 16px; // 1rem -> 16PX
      cursor: pointer;
    }

    .menu-icon-img {
      width: 16px;
      height: 16px;
      margin-right: 16px; // 1rem -> 16PX
      vertical-align: middle;
      cursor: pointer;
    }

    .nav_btns {
      display: none; // 隐藏菜单按钮
    }
  }
}

// 全屏弹窗样式
.menu-dialog-overlay {
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
}

.menu-dialog-content {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu-dialog-close {
  position: absolute;
  right: 28px;
  font-size: 29px;
  color: #888;
  cursor: pointer;
  z-index: 10;
  user-select: none;
  border-radius: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.menu-dialog-divider {
  width: 100%;
  height: 1px;
  background: #eee;
  margin-top: 40px;
  // margin-bottom: 4PX; // 0.5rem -> 8PX
}

.menu-dialog-inner {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  // padding: 56PX 0 0 0; // 3.5rem -> 56PX
}

.menu-list {
  width: 100vw;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  padding: 16px;
  padding-top: 0px;

  .menu-item {
    font-size: 17px; // 1.0625rem -> 17PX
    color: #222;
    padding: 22px 0 22px 0; // 1.375rem -> 22PX
    border-bottom: 1px; // 0.0625rem -> 1PX
    position: relative;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &.expanded .arrow {
      transform: rotate(-135deg);
    }

    .arrow {
      display: inline-block;
      width: 12px; // 1.125rem -> 18PX
      height: 12px; // 1.125rem -> 18PX
      border-right: 2px solid #888; // 0.125rem -> 2PX
      border-bottom: 2px solid #888; // 0.125rem -> 2PX
      transform: rotate(45deg);
      margin-left: 8px; // 0.5rem -> 8PX
      transition: transform 0.2s;
      margin-top: 2px; // 0.125rem -> 2PX
      background: transparent;
      content: "";
    }
  }
}

.submenu-list {
  background: #fff;
  // padding: 0 16px 0 16px; // 1rem -> 16PX

  .submenu-item {
    font-size: 13px; // 0.9375rem -> 15PX
    color: #1e242a;
    padding: 18px 0 6px 0; // 1.125rem -> 18PX
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 600;
    opacity: 1;

    &.expanded .arrow {
      transform: rotate(-135deg);
    }

    .arrow {
      display: inline-block;
      width: 12px; // 1rem -> 16PX
      height: 12px; // 1rem -> 16PX
      border-right: 2px solid #888; // 0.125rem -> 2PX
      border-bottom: 2px solid #888; // 0.125rem -> 2PX
      transform: rotate(45deg);
      margin-left: 8px; // 0.5rem -> 8PX
      transition: transform 0.2s;
      margin-top: 2px; // 0.125rem -> 2PX
      background: transparent;
      content: "";
    }
  }
}

.submenu-list2 {
  background: #fff;
  list-style: none;

  .submenu-item2 {
    font-size: 12px;
    color: #1E242A;
    padding: 11px 0 11px 0;
    background: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }

    .hot {
      color: #f82828;
      border: 1px solid #f82828;
      border-radius: 1px;
      font-size: 9px;
      margin-left: 10px;
      height: 13px;
      line-height: 11px;
      width: 26px;

      text-align: center;
    }

    .submenu-item2-img {
      width: 40px;
      height: 30px;
      object-fit: contain;
      // margin-right: 8px;
      flex-shrink: 0;
    }
  }

  .dialog-content {
  }
}

.btn_confirm {
  width: 120px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
}

.consult-dialog {
  height: 100vh;

  .dialog-content {
    text-align: center;
    width: 100%;

    text-align: center;
    padding: 32px;
    background-image: url("../../assets/home/clockBg.png");
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 215px;

    .icon {
      font-size: 50px;
      color: #0f6bf6;
      margin-bottom: 60px;
      background-image: url("../../assets/home/clock.png"); // 确保图片路径正确
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 70px;
      /* 修改宽度 */
      height: 70px;
      /* 修改高度 */
    }

    p {
      font-family: PingFang SC;
      font-size: 12px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #1e242a;
      opacity: 1;
      margin-bottom: 35px;
    }

    .el-button {
      width: 120px;
      height: 32px;
      font-size: 12px;
      border-radius: 4px;
      background: #0f6bf6;
      margin: 0 auto;
    }
  }
}

.custom-phone-dialog-overlay {
  position: fixed;
  z-index: 3000;
  left: 0;

  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}

.custom-phone-dialog-content {
  border-radius: 4px;
  height: 44px;
  position: relative;
  margin: 40vh 52px;
}

.custom-phone-dialog-close {
  position: absolute;
  right: 12px;
  top: 8px;
  font-size: 24px; // 1.5rem -> 24PX
  color: #333;
  cursor: pointer;
  user-select: none;
  z-index: 10;
}

.phone-label {
  width: 100%;
  display: flex;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  font-family: PingFang SC;
  font-weight: normal;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  margin-bottom: 8px;
}

.consult-dialog {
  ::v-deep .el-dialog__header {
    padding: 0 !important;
  }
}

::v-deep .el-dialog__body {
  padding: 0 !important;
}

::v-deep .el-dialog__footer {
  padding: 10px !important;
}

::v-deep .el-input__inner {
  border: none;
}

.menu-dialog-tabs {
  display: flex;
  flex-direction: row;
  width: 100vw;
  min-height: 100vh;
  background: #fff;
}

.menu-list-tabs {
  width: 120px;
  background: #f8f8f8;
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.menu-tab {
  font-size: 14px; // 1.0625rem -> 17PX
  color: #222;
  padding: 15px 0 15px 0; // 1.375rem -> 22PX
  padding-left: 18px;
  border-left: 2px solid transparent;
  cursor: pointer;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  position: relative;
  transition: color 0.2s, border-color 0.2s;
}

.menu-tab.active {
  color: #0f6bf6;
  border-left: 2px solid #0f6bf6;
  background: #fff;
}

.menu-tab .arrow {
  margin-left: auto;
  margin-right: 12px;
  width: 18px; // 1.125rem -> 18PX
  height: 18px; // 1.125rem -> 18PX
  border-right: 2px solid #888; // 0.125rem -> 2PX
  border-bottom: 2px solid #888; // 0.125rem -> 2PX
  transform: rotate(45deg);
  transition: transform 0.2s;
  background: transparent;
  content: "";
}

.menu-tab.active .arrow {
  border-right: 2px solid #0f6bf6; // 0.125rem -> 2PX
  border-bottom: 2px solid #0f6bf6; // 0.125rem -> 2PX
}

.menu-tab .arrow.up {
  transform: rotate(-135deg);
}

.menu-tab-content {
  flex: 1;
  background: #fff;
  padding: 0 16px;
  overflow-y: auto;
  height: calc(100vh - 50px); // 减去顶部导航高度
  padding-top: 16px;
}

.menu-tab-simple {
  font-size: 17px; // 1.0625rem -> 17PX
  color: #0f6bf6;
  padding: 32px 0 32px 0; // 2rem -> 32PX
  cursor: pointer;
  border-bottom: 1px solid #f2f2f2; // 0.0625rem -> 1PX
  background: #fff;
}

.user_case_dropdown_mobile {
  display: grid;
  grid-template-columns: repeat(2, 1fr); // 修改为一排2个
  gap: 16px;

  .user_case_item {
    position: relative;
    width: 100%;
    height: 130px;
    border-radius: 5px;
    overflow: hidden;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    align-items: center;
    text-align: left;
    transition: background 0.3s;
    border: 5px solid #F8F9F9;
    background: #F8F9F9;
    // 新增：hover时隐藏h4
    .user_case_item-box{
      border-radius: 5px;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    &:hover .user_case_content h4 {
      display: none;
    }

    // 新增：hover时p移动到图片左侧并设置样式
    &:hover .user_case_content p {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 10px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 0px;
      color: #ffffff;
      margin: 0;
      z-index: 2;
    }

    .user_case_content {
      position: relative;
      z-index: 2;
      color: white;
      width: 100%;
      padding-left: 12px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: rgba(30, 36, 42, 0.14);
      h4 {
        font-size: 10px;
        font-weight: bold;
        margin-bottom: 5px;
      }

      p {
        font-size: 9px;
        // 默认样式，hover时会被覆盖
      }
    }

    .arrow_icon {
      position: absolute;
      bottom: 10px;
      right: 10px;
      width: 16px;
      height: 16px;
      z-index: 2;
    }
  }
}

.submenu-item.selected,
.submenu-item2.selected {
  font-weight: bold;
  // color: #0F6BF6;
}
</style>
